import { useQuery } from '@tanstack/react-query';
import { axiosLib } from '@/lib/axios';

export interface Colocation {
  id: number;
  slug: string;
  name: string;
  address: string;
  available_on: string;
  price: string;
  image: string | null;
  virtual_tour_url: string | null;
  is_watched: boolean;
}

interface ColocationsResponse {
  colocations: Colocation[];
}

interface UseColocationsOptions {
  citySlug: string;
}

const fetchColocations = async (citySlug: string): Promise<ColocationsResponse> => {
  const { data } = await axiosLib.get<ColocationsResponse>(`/api/houses/coming_soon`, {
    params: {
      city_slug: citySlug,
    },
  });
  return data;
};

export const useColocations = ({ citySlug }: UseColocationsOptions) => {
  return useQuery({
    queryKey: ['colocations', 'coming-soon', citySlug],
    queryFn: () => fetchColocations(citySlug),
    enabled: Boolean(citySlug),
  });
};
